export default __webpack_public_path__ + "static/media/serviceBanner.f9d957d5.gif";